import $ from "jquery";
import setAppLinksParams from "scripts/components/setAppLinksParams";
import { GAPageView } from "scripts/components/ga/page_view";
import header from "../components/header";
import inputSearch from "../components/inputSearch";
import response from "../components/response";
import forms from "../components/forms";
import modals from "../components/modals";
import stores from "../components/stores";
import map from "../components/maps";
import Select from "../components/select";
import { initSupport } from "scripts/components/support/support";
import { initLazyLoadingRecaptcha } from "scripts/components/recaptcha/recaptcha";
import { installGoogleTranslateShim } from "scripts/utils/googleTranslateShim";

installGoogleTranslateShim();

global.$ = global.jQuery = $;

document.addEventListener("DOMContentLoaded", () => {
  header();
  inputSearch();
  response();
  forms();
  modals();
  stores();
  map();
  window.customSelect = new Select();
  GAPageView();

  setAppLinksParams();
  initSupport();
  initLazyLoadingRecaptcha();

  if ($(".block-seo").length) {
    const wrapper = $(".block-seo .wrapper:not(.opener-holder)");
    const height = wrapper.height();
    const realHeight = wrapper.prop("scrollHeight");

    if (realHeight <= height) {
      $(".block-seo .opener-holder").remove();
    }
  }
  $(".block-seo__opener").on("click", function showSeoText() {
    $(this).parents(".block-seo").toggleClass("active");
  });
});
